export const legal_matter_record_icon = (type) => {
  const icon_map = {
    Supplier: 'bi-building',
    Contract: 'bi-file-earmark-text',
    Procurement: 'bi-briefcase',
    Incident: 'bi-exclamation-diamond',
    Risk: 'bi-shield-exclamation',
    Evidence: 'bi-folder2-open',
    Calendar: 'bi-calendar3',
    Reports: 'bi-file-earmark-bar-graph',
    Employee: 'bi-person',
    'Data privacy': 'bi-shield-lock',
    Insurance: 'bi-shield-check',
    Asset: 'bi-box-seam',
    Exception: 'bi-ban'
  };

  return Reflect.get(icon_map, type) || 'bi-link-45deg';
};

export const legal_matter_check_icon = (state) => {
  const icon_map = {
    good: 'bi-check-circle',
    due: 'bi-exclamation-circle',
    open: 'bi-x-circle'
  };

  return Reflect.get(icon_map, state) ?? 'bi-dot';};

export const legal_matter_check_state_class = (state) => {
  const class_map = {
    good: 'is-green',
    due: 'is-orange',
    open: 'is-red'
  };

  return Reflect.get(class_map, state) || 'is-slate';
};

export const legal_matter_check_badge_class = (state) => {
  const class_map = {
    good: 'bg-success-subtle text-success-emphasis',
    due: 'bg-warning-subtle text-warning-emphasis',
    open: 'bg-danger-subtle text-danger-emphasis'
  };

  return Reflect.get(class_map, state) || 'bg-light text-secondary border border-light';
};
